import { render, staticRenderFns } from "./NewSupplierRegist.vue?vue&type=template&id=2e221ad4&"
import script from "./NewSupplierRegist.vue?vue&type=script&lang=js&"
export * from "./NewSupplierRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports